<template>
  <div id="facebook-login">
    <v-btn @click="sign()" block color="#3C5A9A" dark depressed round>
      <div class="px-3 text-capitalize">
        <v-icon class="mr-2">mdi-facebook</v-icon>กรอกข้อมูลด้วย Facebook
      </div>
    </v-btn>
  </div>
</template>

<script>
import firebase from 'firebase/app'
var provider = new firebase.auth.FacebookAuthProvider()
provider.addScope('public_profile')
provider.setCustomParameters({
  display: 'popup'
})
export default {
  name: 'facebook-login',
  data() {
    return {
      displayName: '',
      photoURL: ''
    }
  },
  methods: {
    sign() {
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(async result => {
          const data = {
            firstname: result.additionalUserInfo.profile.first_name,
            lastname: result.additionalUserInfo.profile.last_name,
            email: result.additionalUserInfo.profile.email,
            phone: result.phoneNumber,
            picture: result.user.photoURL
          }
          await this.$store.commit('FbLogin/SET', data)
          this.signOut()
          // var token = result.credential.accessToken
          // var user = result.user
          // console.log(token, user)
          // console.log('displayName :: ', user.displayName)
          // console.log('photoURL ::', user.photoURL)
          // this.displayName = user.displayName
          // this.photoURL = user.photoURL
        })
        .catch(error => {
          throw new Error(error)
        })
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            // console.log('logOut')
            // this.displayName = ''
            // this.photoURL = ''
          },
          error => {
            throw new Error(error)
          }
        )
    }
  }
}
</script>

<style lang="scss" scoped></style>
